import { useDialog } from "@/client/stores/dialog";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";
import { useFilterPayment } from "@/client/stores/filter";
import { FilterPaymentIntendType } from "libs/dto/src/payment";

import { usefilterUser } from "@/client/services/user/filter-user";
import { useRates } from "@/client/services/rate/rates";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
type NumberFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";

type PaymentFilterFormType = {
  reference?: {
    condition: StringFilterCondition;
    value: string;
  };
  rateId?: {
    condition: StringFilterCondition;
    value: string;
  };
  status?: {
    condition: NumberFilterCondition;
    value: string;
  };
  userId?: {
    condition: StringFilterCondition;
    value: string;
  };
  Amount?: {
    condition: NumberFilterCondition;
    value: string;
  };
  toAmbassador?: {
    condition: NumberFilterCondition;
    value: string;
  };
  openDate?: {
    condition: DateFilterCondition;
    value: string;
  };
  closeDate?: {
    condition: DateFilterCondition;
    value: string;
  };
};

const ObjectConversionToFilterType = (object: PaymentFilterFormType) => {
  const filter: FilterPaymentIntendType = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || field.value == null || Number.isNaN(field.value) || field.value === "") return;

    filter[key as keyof PaymentFilterFormType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterPaymentDialog = () => {
  const { isOpen, close, payload } = useDialog("filter-payment");
  const { filter, replaceFilter } = useFilterPayment();
  const { filterUsers, isLoading } = usefilterUser(false);
  const { rates } = useRates();
  const form = useForm<PaymentFilterFormType>({
    defaultValues: {
      reference: {
        condition: "equals",
        value: "",
      },
      rateId: {
        condition: "equals",
        value: "",
      },
      status: {
        condition: "equals",
        value: "",
      },
      userId: {
        condition: "equals",
        value: "",
      },
      Amount: {
        condition: "equals",
        value: "",
      },
      toAmbassador: {
        condition: "equals",
        value: "",
      },
      openDate: {
        condition: "equals",
        value: "",
      },
      closeDate: {
        condition: "equals",
        value: "",
      },
    },
  });

  const onSubmit = (data: any) => {
    if (data.rateId) data.rateId.condition = "equals";
    if (data.userId) data.userId.condition = "equals";
    if (data.status) data.status.condition = "equals";
    if (data.Amount?.value) data.Amount.value = Number(data.Amount.value);
    if (data.toAmbassador?.value) data.toAmbassador.value = Number(data.toAmbassador.value);
    if (data.status?.value) data.status.value = Number(data.status.value);
    const filterData = ObjectConversionToFilterType(data);
    console.log(filterData);
    replaceFilter(filterData);
    form.reset();
    close();
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{"Filtrer les paiements"}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Tarif"
                  form={form}
                  condition="String"
                  nameField="rateId.condition"
                  disabled
                />
                <FormField
                  name="rateId.value"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un tarif" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {rates?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.price}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Client"
                  form={form}
                  condition="String"
                  nameField="userId.condition"
                  disabled
                />
                <FormField
                  name="userId.value"
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un client" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {isLoading && <>....loading</>}

                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {filterUsers?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.email}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Reference"
                  form={form}
                  condition="String"
                  nameField="reference.condition"
                />
                <Input {...form.register("reference.value")} />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Statut"
                  form={form}
                  condition="Bool"
                  nameField="status.condition"
                  disabled
                />
                <FormField
                  control={form.control}
                  name="status.value"
                  render={({ field }) => (
                    <FormItem>
                      <Select onValueChange={field.onChange} defaultValue={field.value?.toString()}>
                        <SelectTrigger>
                          <SelectValue placeholder="Sélectionner le statut" />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectGroup>
                            <SelectLabel>Statut</SelectLabel>
                            <SelectItem value="0">En attente</SelectItem>
                            <SelectItem value="1">Payé</SelectItem>
                            <SelectItem value="2">Annulé</SelectItem>
                          </SelectGroup>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Montant"
                  form={form}
                  condition="Number"
                  nameField="Amount.condition"
                />
                <Input {...form.register("Amount.value")} type="number" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Commission"
                  form={form}
                  condition="Number"
                  nameField="toAmbassador.condition"
                />
                <Input {...form.register("toAmbassador.value")} type="number" />
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="openDate"
                  form={form}
                  condition="Date"
                  nameField="openDate.condition"
                />
                <Input {...form.register("openDate.value")} type="date" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="closeDate"
                  form={form}
                  condition="Date"
                  nameField="closeDate.condition"
                />
                <Input {...form.register("closeDate.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
              {/* <Button className="bg-moncvpro" onClick={()=> form.reset()}>
                                {"reset"}
                            </Button> */}
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
